import { Component, h } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../../controller/theme_checkout';
import { locale } from '../../../utils/i18n';
import style from './style.css';
import common from '../../../common/common';
import api from '../../../common/api';

class Introduction extends Component {
  constructor(props) {
    super(props);
    this.getStartedClick = this.getStartedClick.bind(this);
  }

  componentDidMount() {
    common.log('onLoad', 'Introduction Page');
  }

  getStartedClick() {
    common.log('onClick', 'Get Started');
    if (this.props && this.props.onKeyValueChange) {
      api
        .updateCheckoutPreference({ prefName: 'isIntroductionPageVisible', prefValue: 'Y' })
        .then(() => {
          //
        })
        .catch(() => {
          //
        });
      this.props.onKeyValueChange('isIntroductionPageVisible', false);
    }
  }

  render() {
    return (
      <div className={`wrapper`}>
        <div className={`${style.introBox}`}>
          <div className={`${style.introLeft} left`}>
            <h2 className={`main-heading ${style['intro-heading']}`}>{locale('checkout.title')}</h2>
            <p className={`${style.subtext} metalic-blue`}>
              Redirection less payment flow, providing a seamless experience that can be easily integrated by just
              dropping a prebuilt code customized for you
            </p>
            <div className={`${style['benefits-heading']}`}>
              <img className={`${style.ribbon}`} src={`${common.getStaticPath()}/assets/images/ribbon.svg`} alt="" />{' '}
              Benefits of {locale('checkout.title')}
            </div>
            <ul className={`${style['intro-list']}`}>
              <li>No redirection</li>
              <li>Integration with minimal code</li>
              <li>Enhanced success rates</li>
              <li>Personalized payments experience for users</li>
              <li>Enhanced brand display with custom UI</li>
              <li>Biggest repository of ~200 million saved cards</li>
              <li>Auto update on addition of payment options</li>
            </ul>
            <div className={`${style['cta-wrap']}`}>
              <button className={`btn btn-primary ${style['cta-btn']}`} onClick={this.getStartedClick}>
                Get Started
              </button>
              {/* <button className={`btn btn-primary ${style['cta-btn']} ${style['cta-btn2']}`}>
                View API docs
              </button> */}
            </div>
          </div>
          <div className={`${style.introRight} right`}>
            <video width="640" height="328" controls>
              <source src={`${common.getStaticPath()}/assets/video/JS-checkout.mp4`} type="video/mp4" />
              <source src={`${common.getStaticPath()}/assets/video/JS-checkout.ogv`} type="video/ogg" />
              <source src={`${common.getStaticPath()}/assets/video/JS-checkout.webm`} type="video/webm" />
              Your browser does not support the video tag.
            </video>
            {/* <iframe width="640" height="328" src="https://www.youtube.com/embed/JH4qVqplC8E" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
          </div>
        </div>
        <div className={`${style['payment-step-info']}`}>
          <h2 className={`text-center ${style['payment-heading']}`}>Be payments ready within an hour</h2>
          <p className={`text-center ${style['payment-para']} metalic-blue`}>
            All you need to do is complete payment page setup by following 3 simple steps
          </p>
          <div className={`${style['step-row']}`}>
            <div className={`${style['step-wrap']}`}>
              <h4>
                Step 1{' '}
                <img
                  className={`${style['arrow-icon']}`}
                  src={`${common.getStaticPath()}/assets/images/ic-arrow-back.svg`}
                  alt=""
                />
              </h4>
              <p className={`metalic-blue`}>
                Easily customize your checkout page design as per your theme and requirements
              </p>
              <img src={`${common.getStaticPath()}/assets/images/step1.png`} alt="" />
              <div className={`${style['content-wrap']}`} />
            </div>
            {/* <div className={`${style['step-arrow']}`}></div> */}
            <div className={`${style['step-wrap']}`}>
              <h4>
                Step 2{' '}
                <img
                  className={`${style['arrow-icon']}`}
                  src={`${common.getStaticPath()}/assets/images/ic-arrow-back.svg`}
                  alt=""
                />{' '}
              </h4>
              <p className={`metalic-blue`}>
                Copy paste single line JS code (customized for you by Paytm) into your script
              </p>
              <img
                className={`${style['content-wrap']}`}
                src={`${common.getStaticPath()}/assets/images/step2.png`}
                alt=""
              />
              <div className={`${style['content-wrap']}`} />
            </div>
            {/* <div className={`${style['step-arrow']}`}></div> */}
            <div className={`${style['step-wrap']}`}>
              <h4>Step 3</h4>
              <p className={`metalic-blue`}>
                Test checkout process in staging environment and gain access to production API keys for going LIVE
              </p>
              <img src={`${common.getStaticPath()}/assets/images/step3.png`} alt="" />
              <div className={`${style['content-wrap']}`} />
            </div>
          </div>
          <div className={`${style['btm-info']} text-center`}>
            <p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://developer.paytm.com/docs/blink-checkout/"
                className={`primary`}
              >
                Learn more
              </a>{' '}
              about {locale('checkout.title')}
            </p>
            <button class="btn btn-primary save" onClick={this.getStartedClick}>
              Get Started
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  'isIntroductionPageVisible',
  onChange
)(Introduction);



// WEBPACK FOOTER //
// ./checkout/components/introduction/index.js